import { Volume2, Mic, Antenna, Headphones, AudioWaveform, Vibrate, Rocket, CloudHail, VolumeX, AudioLines, ArrowRightLeft, FileText, Music, Volume, Gauge, FileAudio } from 'lucide-react';
import type { NavigationItem } from '../types';

export const navigationItems: NavigationItem[] = [
  { 
    icon: Volume2, 
    label: 'Speaker Fix', 
    href: '/',
    description: 'Fix water-damaged speakers'
  },
  { 
    icon: Mic, 
    label: 'Microphone Tester', 
    href: '/microphone-tester',
    description: 'Diagnose Microphone Connectivity Online'
  },
  { 
    icon: Headphones, 
    label: 'Headphones & Earphones Test', 
    href: '/headphones-earphones-test',
    description: 'Test headphones and earphones quality'
  },
  { 
    icon: Antenna, 
    label: 'Speaker Frequency Test', 
    href: '/speaker-frequency-test',
    description: 'Diagnose Speaker Frequency Online'
  },
  { 
    icon: AudioWaveform, 
    label: 'White Noise & Pink Noise Generators', 
    href: '/white-noise-and-pink-noise-generators',
    description: 'White Noise and Pink Noise Generators Online'
  },
  {
    icon: AudioWaveform,
    label: 'Brown Noise Generator',
    href: '/brown-noise-generator',
    description: 'Generate soothing brown noise for relaxation and focus'
  },
  { 
    icon: FileText, 
    label: 'Audio to Text Converter', 
    href: '/audio-to-text',
    description: 'Convert speech to text instantly'
  },
  { 
    icon: Rocket, 
    label: 'MP3 Volume Booster', 
    href: '/mp3-volume-booster',
    description: 'Boost and enhance MP3 audio output up to 600%'
  },
  { 
    icon: CloudHail, 
    label: 'Ambient Noise Cancellation Test', 
    href: '/ambient-noise-cancellation-test',
    description: 'Test noise cancellation capabilities'
  },
  { 
    icon: VolumeX, 
    label: 'Feedback Analyzer Test Online', 
    href: '/feedback-analyzer',
    description: 'Record a sample of the speaker output to analyze and detect distortions or issues.'
  },
  { 
    icon: AudioLines, 
    label: 'Equalizer Settings', 
    href: '/equalizer-settings-online',
    description: 'Customizable equalizer settings to adjust the audio output according to user preferences.'
  },
  { 
    icon: ArrowRightLeft, 
    label: 'Left / Right Stereo Sound Test', 
    href: '/left-right-stereo-sound-test',
    description: 'Test stereo separation and channel balance'
  },
  {
    icon: Mic,
    label: 'Free Online Voice Recorder',
    href: '/online-voice-recorder',
    description: 'Record high-quality audio directly in your browser'
  },
  {
    icon: Music,
    label: 'Voice Changer',
    href: '/voice-changer',
    description: 'Transform your voice with fun effects'
  },
  {
    icon: Volume,
    label: 'Decibel Meter',
    href: '/decibel-meter',
    description: 'Professional sound level measurement tool'
  },
  {
    icon: Gauge,
    label: 'Noise Dosimeter',
    href: '/noise-dosimeter',
    description: 'NIOSH & OSHA compliant noise exposure monitoring'
  },
  {
    icon: FileAudio,
    label: 'Audio Format Converter',
    href: '/audio-format-converter',
    description: 'Convert between MP3, WAV, M4A, OGG, and FLAC formats'
  }
];